import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { StorageService } from "../storage/storage.service";
import { FIREBASE_COLLECTIONS } from "src/app/enums/types.enum";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: "root",
})
export class CartService {
  private API_URL = environment.API_URL;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private firestore: AngularFirestore
  ) {}

  private getToken() {
    let data = this.storageService.get("user");
    const headers = {
      Authorization: `Bearer ${data?.token}`,
    };
    return headers;
  }

  addToCart(payload: any) {
    const headers = this.getToken();
    return new Promise((resolve, reject) => {
      this.http.post(`${this.API_URL}/cart`, payload, { headers }).subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err),
      });
    });
  }

  updateCart(playerId: number | string, payload: any) {
    const headers = this.getToken();
    return new Promise((resolve, reject) => {
      this.http
        .patch(`${this.API_URL}/cart/${playerId}`, payload, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  removeSlotFromCart(playerId: number | string, payload: any) {
    const headers = this.getToken();
    return new Promise((resolve, reject) => {
      this.http
        .put(`${this.API_URL}/cart/remove-slot/${playerId}`, payload, {
          headers,
        })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  getCart = (playerId: string) => {
    return this.http.get(`${this.API_URL}/cart/${playerId}`);
  };
  getCartFromAPI = (playerId: string) => {
    const playerRef = this.firestore.doc(
      `${FIREBASE_COLLECTIONS.USERS}/${playerId}`
    ).ref;

    return this.firestore
      .collection(FIREBASE_COLLECTIONS.CART, (ref) =>
        ref.where("player", "==", playerRef)
      )
      .valueChanges();
  };

  removeCart(playerId: string) {
    const headers = this.getToken();
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${this.API_URL}/cart/${playerId}`, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  checkoutOrder() {
    const headers = this.getToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.API_URL}/api-payAtTheSpotMethod`, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }
}
